// @flow

import { ValidatableMixin } from 'validatable';
import { ExtendedAddress } from 'calc-common';
import type { Observable } from 'rgs-knockout';
import vb from 'validation-builder';
import _ from 'lodash';
import kv from 'rgs-knockout-validation';
import ko from 'rgs-knockout';
import type { IObservableMap } from 'observable-map';
import extendedKladrUtils from 'extended-kladr-utils';
import { compactJoin } from 'common-utils';

export class JuridicalExtendedAddress extends ValidatableMixin(ExtendedAddress) {

	_options: {
		dictionaries: {
			kladr: {
				settlements: IObservableMap,
				streets: IObservableMap,
				houses: IObservableMap,
				regions: IObservableMap
			}
		}
	};

	constructor (options, ...args) {
		super(options, ...args);
		this._options = options;

		this.House.Name.extend({
			validation: vb.all([
				vb.addressHouse(),
				vb.lengthMax(50),
				vb.consecutiveCharRepetitionLimit(3),
			]),
		});

		this.Street.Name.extend({
			validation: vb.all([
				vb.if(() => this.HasStreets() && this.Settlement.Kladr(), vb.all([
					vb.required(),
				])),
			]),
		});

		this.Apartement.extend({
			validation: vb.all([
				vb.addressApartment(),
				vb.lengthMax(5),
				vb.consecutiveCharRepetitionLimit(3),
			]),
		});

		this.Settlement.settlementWithAreaRepr = ko.map(ko.observable(), {
			mapRead: () => {
				if (this.Settlement.Name()) {
					const isNeedRegionName = !extendedKladrUtils.isFederalSettlement(
						this.Settlement.Kladr(),
					);

					return compactJoin(...[
						this.Settlement.Name(),
						this.Settlement.CityName(),
						this.Settlement.AreaName(),
						isNeedRegionName ? this.getRegionName() : null,
					]);
				}
				return '';
			},
			mapWrite: v => {
				if (!v) {
					this.Settlement.AreaName(null);
					this.Settlement.CityName(null);
					this.Settlement.Name(null);
				}
				return v;
			},
		});

	}

	getRegionName = (): string => {
		let regionName = '';

		const kladr = this.Settlement.Kladr();
		if (!kladr) {
			return regionName;
		}

		const regionId = _.toNumber(extendedKladrUtils.getRegionCode(kladr));
		const region = this._options.dictionaries.kladr.regions.get(regionId);
		regionName = region.Name || '';
		return regionName;
	};

	validationArray (): Array<Observable<*>> {
		return []
			.concat(_.filter(this.House, kv.utils.isValidatable))
			.concat(_.filter(this.Street, kv.utils.isValidatable));
	}
}
